/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RedisQueueLength } from '../models/RedisQueueLength';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HealthService {
    /**
     * Ready
     * @returns any Successful Response
     * @throws ApiError
     */
    public static readyHealthReadyGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health/ready',
        });
    }
    /**
     * Startup
     * @returns any Successful Response
     * @throws ApiError
     */
    public static startupHealthStartupGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health/startup',
        });
    }
    /**
     * Live
     * @returns any Successful Response
     * @throws ApiError
     */
    public static liveHealthLiveGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health/live',
        });
    }
    /**
     * @deprecated
     * Get Health
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getHealthHealthPingGet(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health/ping',
        });
    }
    /**
     * Get Redis Queue Length
     * @returns RedisQueueLength Successful Response
     * @throws ApiError
     */
    public static getRedisQueueLengthHealthRedisQueueLengthGet(): CancelablePromise<RedisQueueLength> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health/redis-queue-length/',
        });
    }
}
